import { render, staticRenderFns } from "./AddNewRole.vue?vue&type=template&id=2fb44e62&"
import script from "./AddNewRole.vue?vue&type=script&lang=js&"
export * from "./AddNewRole.vue?vue&type=script&lang=js&"
import style0 from "./AddNewRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports